/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ServiceLevelType } from './';
import {
    ServiceLevelTypeFromJSON,
    ServiceLevelTypeFromJSONTyped,
    ServiceLevelTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminForceServiceLevelChangeRequest
 */
export interface AdminForceServiceLevelChangeRequest {
    /**
     * 
     * @type {ServiceLevelType}
     * @memberof AdminForceServiceLevelChangeRequest
     */
    target: ServiceLevelType;
    /**
     * 
     * @type {string}
     * @memberof AdminForceServiceLevelChangeRequest
     */
    reason: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminForceServiceLevelChangeRequest
     */
    skipEmailNotification: boolean;
}

/**
 * Check if a given object implements the AdminForceServiceLevelChangeRequest interface.
 */
export function instanceOfAdminForceServiceLevelChangeRequest(value: object): value is AdminForceServiceLevelChangeRequest {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('skipEmailNotification' in value) || value['skipEmailNotification'] === undefined) return false;
    return true;
}

export function AdminForceServiceLevelChangeRequestFromJSON(json: any): AdminForceServiceLevelChangeRequest {
    return AdminForceServiceLevelChangeRequestFromJSONTyped(json, false);
}

export function AdminForceServiceLevelChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminForceServiceLevelChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target': ServiceLevelTypeFromJSON(json['target']),
        'reason': json['reason'],
        'skipEmailNotification': json['skipEmailNotification'],
    };
}

export function AdminForceServiceLevelChangeRequestToJSON(value?: AdminForceServiceLevelChangeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'target': ServiceLevelTypeToJSON(value['target']),
        'reason': value['reason'],
        'skipEmailNotification': value['skipEmailNotification'],
    };
}

